import React from 'react';
import EllipsedWithTooltip from '@atlassian/jira-portfolio-3-portfolio/src/common/view/ellipsed-with-tooltip/index.tsx';
import type { Props } from './types.tsx';

export default function TextCustomField(props: Props) {
	const { value } = props;
	return <EllipsedWithTooltip content={value}>{value}</EllipsedWithTooltip>;
}
